import { computed } from "vue";
import { useRoute } from "vue-router";

/**
 * The commit the read-only version view is pinned to, or `null` on the live view.
 *
 * A real historical version: a `version` route param that is present and is not
 * the live sentinel `"current"`. A repeated param arrives as an array and is
 * not a revision, so it reads as live rather than being coerced.
 *
 * This is the single definition of "are we viewing history", shared by the
 * snapshot read and the documents read so the two can never disagree about
 * which commit the page is showing.
 */
export const useHistoricalRevision = () => {
    const route = useRoute();
    return computed(() => {
        const version = route.params.version;
        return typeof version === "string" && version && version !== "current"
            ? version
            : null;
    });
};
